import _             from 'lodash'
import React         from 'react'
import { connect   } from 'react-redux'
import { FormGroup } from 'react-bootstrap'

import { dispatchToProps } from 'alto-utils/lib/store'
import { Select          } from 'alto-react-components/lib/components'
import { selectCanteen   } from 'alto-react-canteen/lib/store/actions'

class CanteenSelection extends React.Component
  render: ->
    if @props.menu and @props.selectedCanteenID
      showMarker = (_.isFunction(@props.menu.otherCanteensAreSaved) and
                    not @props.menu.otherCanteensAreSaved(@props.selectedCanteenID))

      <FormGroup>
        <Select options={@props.menu.canteens.map (canteen) -> [canteen.name, canteen.id]}
                value={@props.selectedCanteenID}
                onChange={(value) => @props.selectCanteen(parseInt(value))} />
        {<span className='dot'>&bull;</span> if showMarker}
      </FormGroup>
    else
      null

mapStateToProps = (state) -> _.pick(state.canteen, 'menu', 'selectedCanteenID')

export default connect(mapStateToProps, dispatchToProps({ selectCanteen }))(CanteenSelection)
